import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button, FormGroup, Label, FormText,
} from 'reactstrap';
import { Field, reduxForm, startSubmit } from 'redux-form';
import * as Actions from '../../actions/campEntryActions';
import { Optional, renderInput } from '../../helpers/formHelper';
import EditableStudentStatusForm from './EditableStudentStatusForm';
import PricePane from './PricePane';

class View extends Component {
  componentDidMount() {
    const { initalizeCampForm, displays } = this.props;
    initalizeCampForm(displays.camp_id);
  }

  render() {
    const {
      submitting, invalid, setSubmittingState, displays, linkSvgPath, prices,
    } = this.props;

    return (
      <form action={`/camp_entry/${displays.camp_id}/${displays.logged_in ? 'student' : 'parent'}`} method="post" onSubmit={() => setSubmittingState('campEntryCamp')}>
        <Field name="authenticity_token" type="hidden" component="input" />
        <EditableStudentStatusForm
          displays={displays}
          linkSvgPath={linkSvgPath}
        />
        <hr />
        <Label>クーポン</Label>
        <Optional />
        <FormGroup>
          <Field
            id="any_code"
            name="any_code"
            type="input"
            component={renderInput}
            disabled={$.isEmptyObject(prices)}
          />
          <FormText color="muted">
            使用できるクーポンコードは一つのみになります。
            <br />
            お申込み後にクーポンを使用することはできません。
          </FormText>
        </FormGroup>
        <hr />
        <PricePane
          isFree={displays.is_free}
          freeMessage={displays.free_message}
          displays={displays}
        />
        <Button
          className="submit"
          type="submit"
          disabled={invalid || submitting}
          color="danger"
          size="lg"
        >
          次へ
        </Button>
        <Button
          className="back"
          color="secondary"
          size="lg"
          disabled={submitting}
          onClick={(e) => {
            e.preventDefault();
            window.location.href = `/camp_entry/${displays.camp_id}/`;
          }}
        >
          もどる
        </Button>
      </form>
    );
  }
}

View.propTypes = {
  initialValues: PropTypes.shape({
    authenticity_token: PropTypes.string,
    parent_status: PropTypes.shape({
      camp_id: PropTypes.number,
    }),
  }).isRequired,
  submitting: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  setSubmittingState: PropTypes.func.isRequired,
  displays: PropTypes.shape({
    camp_id: PropTypes.number.isRequired,
    plans: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      disabled: PropTypes.bool,
    })),
    logged_in: PropTypes.bool.isRequired,
    is_free: PropTypes.bool.isRequired,
    free_message: PropTypes.string,
    is_pc_all_rental: PropTypes.bool.isRequired,
  }).isRequired,
  linkSvgPath: PropTypes.string.isRequired,
  initalizeCampForm: PropTypes.func.isRequired,
  prices: PropTypes.shape({
    couponDiscount: PropTypes.number,
    courponErrors: PropTypes.shape({
      error: PropTypes.string,
    }),
    paymentDiscount: PropTypes.number,
    price: PropTypes.number,
    priceBeforeTax: PropTypes.number,
    ssPrices: PropTypes.shape({
      new_0: PropTypes.shape({
        cancelFee: PropTypes.number,
        cancelRate: PropTypes.number,
        earlyDiscount: PropTypes.number,
        pcRentalFee: PropTypes.number,
        price: PropTypes.number,
        rentalPrices: PropTypes.arrayOf(PropTypes.number),
        total: PropTypes.number,
      }),
    }),
    tax: PropTypes.number,
    totalDiscount: PropTypes.number,
    totalPrice: PropTypes.number,
  }).isRequired,
};

export default reduxForm({
  form: 'campEntryCamp',
  asyncValidate: (values, dispatch) => new Promise((resolve, reject) => {
    dispatch({
      type: Actions.SAGA_IS_COUPON_ERROR_EXIST,
      resolve,
      reject,
    });
  }),
  asyncBlurFields: ['any_code'],
})(connect((state) => ({
  prices: state.campEntry.prices,
}), (dispatch) => ({
  initalizeCampForm: (campId) => dispatch({
    type: Actions.SAGA_INITIALZE_CAMP_FORM,
    payload: { campId },
  }),
  setSubmittingState: (formId) => {
    dispatch(startSubmit(formId));
  },
}))(View));
